import React from 'react'
import ResponsiveImg from '../../common/ResponsiveImg'
import Support1 from '../../../assets/imgs/host/support1.png'
import Support1Dimension from '../../../assets/imgs/host/support1.png?size'
import Support2 from '../../../assets/imgs/host/support2.png'
import Support2Dimension from '../../../assets/imgs/host/support2.png?size'
import Support3 from '../../../assets/imgs/host/support3.png'
import Support3Dimension from '../../../assets/imgs/host/support3.png?size'
import Support4 from '../../../assets/imgs/host/support4.png'
import Support4Dimension from '../../../assets/imgs/host/support4.png?size'
import Support5 from '../../../assets/imgs/host/support5.png'
import Support5Dimension from '../../../assets/imgs/host/support5.png?size'
import Support6 from '../../../assets/imgs/host/support6.png'
import Support6Dimension from '../../../assets/imgs/host/support6.png?size'
import styles from './Support.scss'

const Support = () => <>
  <div className={[styles.background].join(' ')}>
  <div className={[styles.container].join(' ')}>
    <div className={[styles.space120].join(' ')}/>
    <h2 className={[styles.title].join(' ')}>
      初めての方も安心！<span className={styles.otherFont}><br className='d-block d-md-none'/>Carstay</span>のホストサポート
    </h2>
    <div className={[styles.descText, styles.text].join(' ')}>
      シェアリングサービスが初めての方にも安心なサポート体制を整えています
    </div>
    <div className='row m-0 d-flex justify-content-between'>
      <div className={['d-flex p-0 m-0', styles.djColumn1].join(' ')}>
        <div className={['d-md-block d-none p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={84}
            height={84}
            url={Support1}
            caption="Support1"
            srcSet={Support1}
            dimension={Support1Dimension}
          />
        </div>
        <div className={['d-block d-md-none p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={72}
            height={72}
            url={Support1}
            caption="Support1"
            srcSet={Support1}
            dimension={Support1Dimension}
          />
        </div>
        <div className={['p-0', styles.textContainer].join(' ')}>
          <h3 className={[styles.subTitle].join(' ')}>カスタマーサポートが充実</h3>
          <p className={['mb-0', styles.text, styles.ls2].join(' ')}>
            トラブルやご不明点などお困りの際はメールにて
            <span className={[styles.otherFont, styles.fw3, styles.font].join(' ')}>Carstay</span>のカスタマーサポートが対応いたします
          </p>
        </div>
      </div>
      <div className={['d-flex p-0', styles.djColumn2].join(' ')}>
        <div className={['d-md-block d-none p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={84}
            height={84}
            url={Support2}
            caption="Support2"
            srcSet={Support2}
            dimension={Support2Dimension}
          />
        </div>
        <div className={['d-block d-md-none p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={72}
            height={72}
            url={Support2}
            caption="Support2"
            srcSet={Support2}
            dimension={Support2Dimension}
          />
        </div>
        <div className={['p-0', styles.textContainer].join(' ')}>
          <h3 className={[styles.subTitle].join(' ')}>支払情報の入力必須</h3>
          <p className={['mb-0', styles.text].join(' ')}>
            ゲストは支払情報（クレジットカード情報）を登録し決済が確認できた場合のみ、予約が成立します
          </p>
        </div>
      </div>
      <div className={['d-flex p-0', styles.djColumn2].join(' ')}>
        <div className={['d-md-block d-none p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={84}
            height={84}
            url={Support3}
            caption="Support3"
            srcSet={Support3}
            dimension={Support3Dimension}
          />
        </div>
        <div className={['d-block d-md-none p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={72}
            height={72}
            url={Support3}
            caption="Support3"
            srcSet={Support3}
            dimension={Support3Dimension}
          />
        </div>
        <div className={['p-0', styles.textContainer].join(' ')}>
          <h3 className={[styles.subTitle].join(' ')}>各種マニュアルをご用意</h3>
          <p className={['mb-0', styles.text].join(' ')}>
            予約増加の工夫をまとめたマニュアル、ゲストの受付をする際のマニュアルなどをご用意し運用面でサポートいたします
          </p>
        </div>
      </div>
    </div>
    <div className='row m-0 d-flex justify-content-between'>
      <div className={['d-flex p-0', styles.djColumn1].join(' ')}>
        <div className={['d-md-block d-none p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={85}
            height={85}
            url={Support4}
            caption="Support4"
            srcSet={Support4}
            dimension={Support4Dimension}
          />
        </div>
        <div className={['d-block d-md-none  p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={72}
            height={72}
            url={Support4}
            caption="Support4"
            srcSet={Support4}
            dimension={Support4Dimension}
          />
        </div>
        <div className={['pr-0', styles.textContainer].join(' ')}>
          <h3 className={['', styles.subTitle].join(' ')}>カレンダー・在庫管理機能</h3>
          <p className={['mb-0', styles.text].join(' ')}>
            空き状況を登録できるカレンダー機能と在庫管理機能により、駐車場や空き地を使わない時だけゲストの予約を受け付けられます
          </p>
        </div>
      </div>
      <div className={['d-flex p-0', styles.djColumn2].join(' ')}>
        <div className={['d-md-block d-none p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={84}
            height={84}
            url={Support5}
            caption="Support5"
            srcSet={Support5}
            dimension={Support5Dimension}
          />
        </div>
        <div className={['d-block d-md-none p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={72}
            height={72}
            url={Support5}
            caption="Support5"
            srcSet={Support5}
            dimension={Support5Dimension}
          />
        </div>
        <div className="px-0">
          <h3 className={['', styles.subTitle].join(' ')}>チャット機能</h3>
          <p className={['mb-0', styles.text].join(' ')}>
            ゲストからの質問の受付や、ホストからの施設利用案内など、利用前〜利用後まで都度チャットを通してコミュニケーションをとることができます
          </p>
        </div>
      </div>
      <div className={['d-flex p-0', styles.djColumn1].join(' ')}>
        <div className={['d-md-block d-none p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={85}
            height={85}
            url={Support6}
            caption="Support6"
            srcSet={Support6}
            dimension={Support6Dimension}
          />
        </div>
        <div className={['d-block d-md-none p-0', styles.supportIcon].join(' ')}>
          <ResponsiveImg
            width={72}
            height={72}
            url={Support6}
            caption="Support6"
            srcSet={Support6}
            dimension={Support6Dimension}
          />
        </div>
        <div className="px-0">
          <h3 className={[styles.subTitle].join(' ')}>コミュニティの運営</h3>
          <p className={['mb-0', styles.text, styles.ls2].join(' ')}>
            ホルダー・ホスト限定の<span className={styles.fw4}>Facebook</span>グループを運営し、ホスト間でノウハウを共有する機会を設けています
          </p>
        </div>
      </div>
    </div>
  </div>
<div className={styles.space72}/>
</div>
</>
Support.displayName = 'Support'
export default Support
